import React from "react";

const CertificateTemplateFilters = ({
  filters,
  courseworkOptions,
  environmentOptions,
  trainingProviderOptions,
  proficiencyOptions,
  isMobile,
  handleFilterChange,
  handleApply,
  handleReset,
}) => (
  <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
    <div className={`certificate-templates-filters ${isMobile ? 'flex flex-col gap-4' : 'grid grid-cols-4 gap-4'} mb-6`}>
      {/* Coursework Filter */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Coursework</label>
        <select
          value={filters.coursework}
          onChange={e => handleFilterChange('coursework', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900"
        >
          <option value="All">All</option>
          {courseworkOptions.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
      {/* Environment Filter */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Environment</label>
        <select
          value={filters.environment}
          onChange={e => handleFilterChange('environment', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900"
        >
          <option value="All">All</option>
          {environmentOptions.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
      {/* Training Provider Filter */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Training Provider</label>
        <select
          value={filters.trainingProvider}
          onChange={e => handleFilterChange('trainingProvider', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900"
        >
          <option value="All">All</option>
          {trainingProviderOptions.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
      {/* Proficiency Filter */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Proficiency</label>
        <select
          value={filters.proficiency}
          onChange={e => handleFilterChange('proficiency', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900"
        >
          <option value="All">All</option>
          {proficiencyOptions.map(option => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
    </div>
    {/* Filter Buttons */}
    <div className={`filter-buttons ${isMobile ? 'flex flex-col gap-3' : 'flex justify-end gap-4'}`}>
      <button
        onClick={handleApply}
        className="hover:bg-blue-500 text-blue-500 hover:text-white outline outline-blue-500 font-bold py-2 px-12 rounded-full"
        style={{
          minHeight: isMobile ? "44px" : undefined,
          fontSize: isMobile ? "16px" : undefined,
          padding: isMobile ? "12px 24px" : undefined,
          width: isMobile ? "100%" : undefined,
          maxWidth: isMobile ? "300px" : undefined
        }}
      >
        Apply
      </button>
      <button
        onClick={handleReset}
        className="hover:bg-red-500 text-red-500 hover:text-white outline outline-red-500 font-bold py-2 px-12 rounded-full"
        style={{
          minHeight: isMobile ? "44px" : undefined,
          fontSize: isMobile ? "16px" : undefined,
          padding: isMobile ? "12px 24px" : undefined,
          width: isMobile ? "100%" : undefined,
          maxWidth: isMobile ? "300px" : undefined
        }}
      >
        Reset
      </button>
    </div>
  </div>
);

export default CertificateTemplateFilters;